var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobalAdmins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9H1",
    stroke: "#003393",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#003393",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C12 11.3789 11.5695 13.4844 10.9146 14.9578C10.5866 15.6958 10.222 16.2311 9.8676 16.5683C9.51836 16.9007 9.2269 17 9 17C8.7731 17 8.48164 16.9007 8.1324 16.5683C7.77801 16.2311 7.41337 15.6958 7.08538 14.9578C6.43054 13.4844 6 11.3789 6 9C6 6.62114 6.43054 4.51558 7.08538 3.04218C7.41337 2.30422 7.77801 1.76892 8.1324 1.43166C8.48164 1.0993 8.7731 1 9 1C9.2269 1 9.51836 1.0993 9.8676 1.43166C10.222 1.76892 10.5866 2.30422 10.9146 3.04218C11.5695 4.51558 12 6.62114 12 9Z",
    stroke: "#003393",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalAdmins);
export default __webpack_public_path__ + "static/media/global_admins.a5b9f2ceb3be82c675860e6cead0e464.svg";
export { ForwardRef as ReactComponent };